import { Component, OnInit } from '@angular/core';
import { HeadComponent } from '../../template/sidebar-header/head.component';


@Component({
  selector: 'crypto-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
